// @flow

import React, { Component } from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { get, noop } from 'lodash';

import 'web-ssr/app/common/components/TextInput.scss';

import type { KindType } from 'web-ssr/app/common/types';

const bem = bemify('text-input');

type Props = {
  name: string,
  kind?: KindType,
  className?: string,
  onBlur?: () => void,
  onChange: (value: string) => void,
  onFocus?: () => void,
  placeholder: string,
  type: string,
  value?: string,
  id?: string,
  disabled?: boolean,
  autoComplete?: string | boolean,
  isMultiLine?: boolean,
  error?: boolean,
};

class TextInput extends Component<Props> {
  setTextValue = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const value = get(e, ['target', 'value'], '');

    this.props.onChange(value);
  };

  render() {
    const {
      id,
      name,
      value,
      placeholder,
      onFocus = noop,
      onBlur = noop,
      type = 'text',
      className,
      autoComplete,
      disabled,
      kind,
      isMultiLine,
      error,
    } = this.props;

    const InputTag = isMultiLine ? 'textarea' : 'input';

    const inputType = isMultiLine ? undefined : type;

    return (
      <InputTag
        aria-invalid={error}
        autoComplete={autoComplete}
        className={bem(className, toModifiers({ disabled, error }, kind))}
        disabled={disabled}
        id={id}
        name={name}
        onBlur={onBlur}
        onChange={this.setTextValue}
        onFocus={onFocus}
        placeholder={placeholder}
        type={inputType}
        value={value}
      />
    );
  }
}

export default TextInput;
